import { useState } from "react";

const suppliers = ["TechDistribütör", "GlobalSupply", "ElektronikToptan", "OfisDepo"];
const categories = ["Elektronik", "Aksesuar", "Ofis", "Giyim"];

const allData = [
  { date: "2026-07-16", product: "Kablosuz Mouse", category: "Elektronik", brand: "Logitech", qty: 50, unitPrice: 280, total: 14000, supplier: "TechDistribütör", docNo: "ALŞ-2026-001" },
  { date: "2026-07-15", product: "Mechanik Klavye", category: "Elektronik", brand: "Corsair", qty: 30, unitPrice: 750, total: 22500, supplier: "GlobalSupply", docNo: "ALŞ-2026-002" },
  { date: "2026-07-14", product: "27\" Monitör", category: "Elektronik", brand: "Samsung", qty: 15, unitPrice: 2400, total: 36000, supplier: "ElektronikToptan", docNo: "ALŞ-2026-003" },
  { date: "2026-07-13", product: "USB-C Hub", category: "Aksesuar", brand: "Dell", qty: 80, unitPrice: 180, total: 14400, supplier: "TechDistribütör", docNo: "ALŞ-2026-004" },
  { date: "2026-07-12", product: "Webcam 1080p", category: "Elektronik", brand: "Logitech", qty: 40, unitPrice: 420, total: 16800, supplier: "GlobalSupply", docNo: "ALŞ-2026-005" },
  { date: "2026-07-11", product: "Laptop Standı", category: "Aksesuar", brand: "HP", qty: 60, unitPrice: 150, total: 9000, supplier: "OfisDepo", docNo: "ALŞ-2026-006" },
  { date: "2026-07-10", product: "Masa Lambası LED", category: "Ofis", brand: "Samsung", qty: 100, unitPrice: 95, total: 9500, supplier: "OfisDepo", docNo: "ALŞ-2026-007" },
  { date: "2026-07-09", product: "Hoparlör 2.1", category: "Elektronik", brand: "Logitech", qty: 20, unitPrice: 520, total: 10400, supplier: "ElektronikToptan", docNo: "ALŞ-2026-008" },
];

export default function PurchasesReport() {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [supplier, setSupplier] = useState("");
  const [product, setProduct] = useState("");
  const [category, setCategory] = useState("");

  const data = allData.filter((i) => {
    if (startDate && i.date < startDate) return false;
    if (endDate && i.date > endDate) return false;
    if (supplier && i.supplier !== supplier) return false;
    if (product && !i.product.toLowerCase().includes(product.toLowerCase())) return false;
    if (category && i.category !== category) return false;
    return true;
  });

  const total = data.reduce((sum, d) => sum + d.total, 0);

  return (
    <div className="space-y-4">
      <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <div className="bg-secondary-500 px-4 py-3 flex items-center justify-between">
          <span className="text-sm font-semibold text-background-50">Alışlar Rapor Kriterleri</span>
          <button onClick={() => { setStartDate(""); setEndDate(""); setSupplier(""); setProduct(""); setCategory(""); }} className="text-xs text-background-50/80 hover:text-background-50 transition-colors cursor-pointer">Temizle</button>
        </div>
        <div className="p-4 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="sm:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tarih Aralığı</label>
            <div className="flex items-center gap-2">
              <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
              <span className="text-sm text-foreground-400">-</span>
              <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} className="flex-1 px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Tedarikçi</label>
            <select value={supplier} onChange={(e) => setSupplier(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400 cursor-pointer">
              <option value="">Tümü</option>
              {suppliers.map((s) => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label className="block text-xs font-medium text-foreground-600 mb-1">Kategori</label>
            <select value={category} onChange={(e) => setCategory(e.target.value)} className="w-full px-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400 cursor-pointer">
              <option value="">Tümü</option>
              {categories.map((c) => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
          <div className="sm:col-span-2 lg:col-span-2">
            <label className="block text-xs font-medium text-foreground-600 mb-1">Ürün Ara</label>
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400"></i>
              <input type="text" placeholder="Ara..." value={product} onChange={(e) => setProduct(e.target.value)} className="w-full pl-9 pr-3 py-2 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-secondary-400" />
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground-950">Alış Listesi</h2>
        <div className="flex items-center gap-3">
          <span className="text-sm text-foreground-500">{data.length} kayıt</span>
          <span className="text-sm font-semibold text-secondary-600">Toplam: ${total.toLocaleString("en-US")}</span>
        </div>
      </div>

      <div className="hidden lg:block bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-background-100 border-b border-background-200/70">
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Belge No</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Tarih</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Ürün</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Marka</th>
              <th className="px-4 py-3 text-center font-medium text-foreground-600">Adet</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Birim Fiyat</th>
              <th className="px-4 py-3 text-right font-medium text-foreground-600">Toplam</th>
              <th className="px-4 py-3 text-left font-medium text-foreground-600">Tedarikçi</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item, idx) => (
              <tr key={idx} className="border-b border-background-200/50 hover:bg-background-100/50 transition-colors">
                <td className="px-4 py-3 text-foreground-500">{item.docNo}</td>
                <td className="px-4 py-3 text-foreground-500">{item.date}</td>
                <td className="px-4 py-3 font-medium text-foreground-900">{item.product}</td>
                <td className="px-4 py-3 text-foreground-500">{item.brand}</td>
                <td className="px-4 py-3 text-center text-foreground-900">{item.qty}</td>
                <td className="px-4 py-3 text-right text-foreground-500">${item.unitPrice.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-right font-semibold text-foreground-900">${item.total.toLocaleString("en-US")}</td>
                <td className="px-4 py-3 text-foreground-500">{item.supplier}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="lg:hidden space-y-3">
        {data.map((item, idx) => (
          <div key={idx} className="bg-background-50 border border-background-200/70 rounded-xl p-4">
            <div className="flex items-start justify-between">
              <div>
                <p className="text-sm font-medium text-foreground-900">{item.product}</p>
                <p className="text-xs text-foreground-400">{item.brand} · {item.date} · {item.docNo}</p>
              </div>
              <p className="text-sm font-bold text-foreground-900">${item.total.toLocaleString("en-US")}</p>
            </div>
            <p className="text-xs text-foreground-500 mt-2">{item.qty} adet · {item.supplier}</p>
          </div>
        ))}
      </div>
    </div>
  );
}